export default __webpack_public_path__ + "static/media/goat.2883465f.mp4";